import { createFileRoute } from '@tanstack/react-router';
import { GroundworkReportsClient } from '@/features/groundwork/GroundworkReportsClient';

export const Route = createFileRoute('/_shell/groundwork')({
  component: GroundworkReportsClient,
});
